module.exports = __webpack_public_path__ + "img/Pic-4.705b4b76.png";